<template>
  <div >
    <Navbar/>
    <div class="background">
      <div class="row">
        <div class="col d-none d-md-block" >
          <div >
            <div data-aos="slide-left" data-aos-duration="10000">
              <img src="../../assets/images/feature-app-image.jpg" width="100%" height="100%" />
            </div>
          </div>

        </div>
        <div class="col " >
          <div class="hero-content-info newForm px-2"
               data-aos="slide-right"
               data-aos-duration="10000">
            <div class="col-12 text-center mb-4">
              <h1>Log In</h1>
            </div>
            <div class="col-sm-5 m-auto">
              <div v-if="errorMessage !== ''" class="alert alert-danger" role="alert">
                {{ errorMessage }}
              </div>
              <div v-if="successMessage !== ''" class="alert alert-success" role="alert">
                {{ successMessage }}
              </div>
              <form @submit.prevent="loginRequest" id="login-form">
                <div class="row text-left" >
                  <div class="col-sm-12 form-group">
                    <label for="email">Email Address</label>
                    <input type="email" v-model="email" id="email" class="form-control form-control-lg">
                  </div>
                  <div class=" col-sm-12 form-group mb-4">
                    <label for="password">Password</label>
                    <input type="password" v-model="password" id="password" class="form-control form-control-lg">
                  </div>
                  <div class="col-sm-12 text-center form-group ">
                    <button v-bind:disabled="xhrRequest" v-bind:class="{disabled: xhrRequest}" class="btn btn-lg btn-primary px-4">
                      <span v-if="! xhrRequest">Login</span>
                      <span v-if="xhrRequest">Please Wait...</span>
                    </button>
                    <div v-if="xhrRequest" class="spinner-border text-secondary loader" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div class="col-sm-12 text-center form-group mt-5">
                    <p>No tienes una cuenta <a href="/#/register">Registrarse</a></p>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>
<script>
import Navbar from "@/components/Navbar";
import axios from "axios";
import constants from "@/utils/constants";
import {isEmpty } from 'lodash';

export default {
  name: "Login",
  components:{
    Navbar
  },
  data() {
    return {
      email: "",
      password: "",
      xhrRequest: false,
      errorMessage: "",
      successMessage: "",
      isLogin:false
    }
  },
  methods: {
    loginRequest() {
      let v = this;
      v.xhrRequest = true;
      v.errorMessage = "";
      v.successMessage = "";
      let post = {
        email: v.email,
        password: v.password,
        returnSecureToken: true
      };
      axios.post(constants.endpointList.login, post).then((result) => {
        let postData = result.data;
        if(isEmpty(postData.error)){
          v.xhrRequest = false;
          this.$store.dispatch('setJWT', JSON.stringify(postData))
          this.$store.dispatch('setLogin',true);
          this.$router.push('/dashboard');
        }
        v.errorMessage = "Error";
        v.xhrRequest = false;


      });

    }
  },

  created: function(){
    this.isLogin = this.$store.getters.isLogin;
    if(this.isLogin === true){
      this.$router.push('/dashboard');
    }
  }
}

</script>
<style scoped>
.loader {
  position:relative;
  top:6px;
  left:10px;
}
.newForm{
  margin-top: 100px;
}
.newInput{

}
.img-container{
  position: absolute;
  width: 100%;
}
</style>
